import script from "./card-header-tips.vue?vue&type=script&setup=true&lang=js"
export * from "./card-header-tips.vue?vue&type=script&setup=true&lang=js"

import "./card-header-tips.vue?vue&type=style&index=0&id=e369443a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e369443a"]])

export default __exports__